import { SettingOutlined, LogoutOutlined, ProfileOutlined } from "@ant-design/icons";
import { Avatar, Button, Dropdown } from "antd";
import styles from './UserProfileMenu.module.scss'; // Import du SCSS modulaire
import { useCallback } from "react";
import UserService from "../../services/UserService";
import { catchError, removeToken } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import { useUserContext } from "../../contexts/UserContext";

export default function UserProfileMenu() {

    const { currentUser } = useUserContext();

    const logout = useCallback(() => {
        UserService.getInstance()
            .logout()
            .then((response) => {
                Toast.success(response.message);
                removeToken();
                window.location.href = "/login";
            }).catch((error) => {
                catchError(error);
            });
    }, []);

    const menuItems = [
        {
            label: (
                <div className={`fw-bold text-center ${styles.userProfileSection}`}>
                    {currentUser?.name}
                    <br />
                    <small>{currentUser?.email}</small>
                </div>
            ),
        },
        {
            label: (
                <a href="/profile" className={styles.menuItem}>
                    <ProfileOutlined className={styles.menuIcon} /> Mon Profil
                </a>
            ),
            key: 'profile',
        },
        {
            label: (
                <a href="/settings" className={styles.menuItem}>
                    <SettingOutlined className={styles.menuIcon} /> Paramètres
                </a>
            ),
            key: 'settings',
        },
        {
            type: 'divider',
        },
        {
            label: (
                <Button type="link" className={styles.menuItem} onClick={logout}>
                    <LogoutOutlined className={styles.menuIcon} /> Déconnexion
                </Button>
            ),
            key: 'logout',
        }
    ];

    return (
        <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
            <div className={styles.avatarWrap}>
                <Avatar className={styles.avatar} src={currentUser?.avatar} size={30}>
                    {!currentUser?.avatar && currentUser?.name?.charAt(0).toUpperCase()}
                </Avatar>
                <span className={styles.avatarName}>{currentUser?.name}</span>
            </div>
        </Dropdown>
    );
}
